import { useState } from "react";
import Box from "@mui/material/Box";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import React, { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import "./StepForm.css";
import Personal_Details from "./personal_Details/Personal_Details";
import Driving_School_Details from "./driving_School_Details/Driving_School_Details";
import Subscription_Plan from "./subscription_Plan/Subscription_Plan";
import Procced_to_payment from "./procced_to_payment/Procced_to_payment";
import Congratulations_step from "./congratulations_step/Congratulations_step";
import { GetVendorFullDetails, GetallSubscription } from "../../../features/admin/common/Slice";
const steps = [
  "Personal Details",
  "Driving School Details",
  "Subscription Plan",
  "Proceed to Payment",
  "Congratulations",
];


function StepForm({ setCurrentStep }) {

  const all_subscription = useSelector((state) => state.common.all_subscription);
  const [selectedPlan, setSelectedPlan] = useState(null);  // store full details
  const [userId, setUserId] = useState(null);

  const dispatch = useDispatch();

   
const [activePlan, setActivePlan] = useState(null);



   console.log("userId from Stepform", userId);


  console.log("all_subscriptionall_subscriptionall_subscription", all_subscription);


  useEffect(() => {
    dispatch(GetallSubscription());
  }, [dispatch]);


  const [step, setStep] = useState(1);
  const nextStep = () => {
    setStep((prev) => {
      const newStep = Math.min(prev + 1, steps.length);
      setCurrentStep?.(newStep);
      return newStep;
    });
  };

  const prevStep = () => {
    setStep((prev) => {
      const newStep = Math.max(prev - 1, 1);
      setCurrentStep?.(newStep);
      return newStep;
    });
  };

  const renderStepContent = () => {
    switch (step) {
      case 1:
        return <Personal_Details nextStep={nextStep} setUserId={setUserId} userId={userId}  />;
      case 2:
        return <Driving_School_Details nextStep={nextStep} prevStep={prevStep} userId={userId} />;
      case 3:
        return <Subscription_Plan nextStep={nextStep} prevStep={prevStep} all_subscription={all_subscription} setSelectedPlan={setSelectedPlan} />;
      case 4:
        return <Procced_to_payment nextStep={nextStep} prevStep={prevStep} selectedPlan={selectedPlan} userId={userId} />;
      case 5:
        return <Congratulations_step prevStep={prevStep} activePlan={activePlan}/>;
      default:
        return null;
    }
  };

  // Only show first 3 steps in Stepper
  const visibleSteps = steps.slice(0, 3);

  return (
    <div className="stepform_form">
      {/* This condition checks if the current step is 3 or less.
        If it is, the Stepper (Box) is rendered.
        If it's step 4 or 5, this block is hidden.
      */}
      {step <= 3 && (
        <Box sx={{ width: "100%", mb: 4 }}>
          <Stepper activeStep={Math.min(step - 1, 2)} alternativeLabel>
            {visibleSteps.map((label) => (
              <Step key={label}>
                <StepLabel>{label}</StepLabel>
              </Step>
            ))}
          </Stepper>
        </Box>
      )}

      <div className="step-content">{renderStepContent()}</div>
    </div>
  );
}

export default StepForm;